import { t } from 'i18next'
import React from 'react'
import { useForm } from 'react-hook-form'
import { useEtracker } from '../../../hooks/use-etracker'
import { Button } from '../../button/button'
import { RadioButtonGroup } from '../../radio-button-group/radio-button-group'
import styles from '../exit-feedback-modal.module.css'

interface NoMatchesExitFormProps {
	onSubmit: () => void
	exitButtonSlot?: React.ReactNode
}

export const NoMatchesExitForm: React.FC<NoMatchesExitFormProps> = ({ onSubmit, exitButtonSlot }) => {
	const {
		register,
		handleSubmit,

		formState: { errors },
	} = useForm({
		mode: 'onSubmit',
	})
	const { trackExitEvent } = useEtracker()

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const handleFormSubmit = (data: any) => {
		// First question: Awareness of job board
		const awarenessAnswer =
			jobBoardAwarenessOptions.find((option) => option.value === data['job-board-awareness'])?.label || ''
		trackExitEvent(t('exitFeedback.formNoMatches.jobBoardAwareness.label'), awarenessAnswer)

		// Second question: Return likelihood
		const returnLikelihood = data['return-likelihood']
		const returnLikelihoodAnswer =
			returnLikelihoodOptions.find((option) => option.value === returnLikelihood)?.label || returnLikelihood
		trackExitEvent(t('exitFeedback.formNoMatches.returnLikelihood.label'), returnLikelihoodAnswer)

		if (onSubmit) {
			onSubmit()
		}
	}

	const jobBoardAwarenessOptions = [
		{ value: 'yes', label: t('exitFeedback.formNoMatches.jobBoardAwareness.options.yes') },
		{ value: 'no', label: t('exitFeedback.formNoMatches.jobBoardAwareness.options.no') },
	]

	const returnLikelihoodOptions = [
		{ value: 'very-likely', label: t('exitFeedback.formNoMatches.returnLikelihood.options.veryLikely') },
		{ value: 'likely', label: t('exitFeedback.formNoMatches.returnLikelihood.options.likely') },
		{ value: 'not-likely', label: t('exitFeedback.formNoMatches.returnLikelihood.options.notLikely') },
	]

	return (
		<form className={styles.form} onSubmit={handleSubmit(handleFormSubmit)}>
			<div className={styles.fields}>
				<RadioButtonGroup
					name="job-board-awareness"
					label={t('exitFeedback.formNoMatches.jobBoardAwareness.label')}
					options={jobBoardAwarenessOptions}
					className={styles.formGroup}
					register={register}
					registerOptions={{ required: t('exitFeedback.fieldRequired') }}
					error={errors['job-board-awareness'] && t('exitFeedback.fieldRequired')}
				/>

				<RadioButtonGroup
					name="return-likelihood"
					label={t('exitFeedback.formNoMatches.returnLikelihood.label')}
					options={returnLikelihoodOptions}
					className={styles.formGroup}
					register={register}
					registerOptions={{ required: t('exitFeedback.fieldRequired') }}
					error={errors['return-likelihood'] && t('exitFeedback.fieldRequired')}
				/>
			</div>

			<div className={styles.buttons}>
				{exitButtonSlot}
				<Button className={styles.submit} type="primary" submit={true}>
					{t('exitFeedback.submit')}
				</Button>
			</div>
		</form>
	)
}
